import { deleteData, getData, patchData, postData, putData } from "../apiClient";

/**
 * Retrieves the global reference list of currencies.
 */
export const getCurrencyList = async () => {
  try {
    const result = await getData("/currency/get-currency-list");
    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error("Get currency list API error:", error);
    return {
      success: false,
      error: error.message,
      data: [],
    };
  }
};

/**
 * Retrieves a single system currency record by ID.
 */
export const getCurrencyById = async (id) => {
  try {
    const result = await getData(`/currency/getOne/${id}`);
    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error("Get Currency by ID API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Retrieves paginated list of system currencies.
 */
export const getCurrencies = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(
      `/currency/get/?${queryParams}`,
      {},
      {},
      signal,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get currencies API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Creates a new system currency.
 */
export const createCurrency = async ({ data }) => {
  try {
    const result = await postData(`/currency/create`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Create currency API error:", error);
    return {
      data: {
        success: false,
        error:
          error.status === 400 || error.status === 409
            ? error.error
            : error.message,
        status: error.status,
      },
    };
  }
};

/**
 * Updates an existing system currency.
 */
export const updateCurrency = async ({ currencyid, data }) => {
  try {
    const result = await putData(`/currency/update/${currencyid}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update currency API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

/**
 * Deletes a system currency.
 */
export const deleteCurrency = async ({ id }) => {
  try {
    const result = await deleteData(`/currency/delete/${id}`);
    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error("Delete currency API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Sets a currency as the system default.
 */
export const setDefaultCurrency = async (id) => {
  try {
    const result = await patchData(`/currency/set-default/${id}`);
    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error("Set default currency API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Retrieves all configured system currencies (non-paginated).
 */
export const getCurrencyOptions = async () => {
  try {
    const result = await getData("/currency/get-options");
    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error("Get currency options API error:", error);
    return {
      success: false,
      error: error.message,
      data: [],
    };
  }
};